import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cashews from '../assets/banners/cashew.jpg';
import { FaSeedling, FaBoxOpen, FaShippingFast, FaRegCheckCircle } from 'react-icons/fa';

const Cashew = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const [email, setEmail] = useState('');

    const handleEnquiry = () => {
        const subject = encodeURIComponent("Cashew Order Enquiry");
        const body = encodeURIComponent(
            `Hi,\n\nI am interested in placing an order or getting a quotation for your cashews.\n\nPlease contact me back at: ${email}\n\nThanks,\n`
        );
        window.location.href = `mailto:yourmail@example.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="text-gray-800 bg-white">
            {/* Hero Section */}
            <section className="bg-yellow-100 py-16 px-4 text-center" data-aos="fade-down">
                <h1 className="text-4xl md:text-5xl font-bold text-yellow-700 mb-4">Premium Cashews</h1>
                <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
                    Handpicked, sun-dried cashews with natural crunch. Ideal for snacking, gourmet dishes, or gifting worldwide.
                </p>
            </section>

            {/* Image and Details Section */}
            <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10 items-center">
                <div data-aos="zoom-in">
                    <img
                        src={Cashews}
                        alt="Cashews"
                        className="rounded-xl shadow-xl"
                    />
                </div>
                <div data-aos="fade-left">
                    <h2 className="text-3xl font-semibold text-yellow-700 mb-6">Why Choose Our Cashews?</h2>
                    <ul className="space-y-4 text-gray-700">
                        <li className="flex items-start gap-3"><FaRegCheckCircle className="text-yellow-600 mt-1" />100% natural, hand-sorted & chemical-free</li>
                        <li className="flex items-start gap-3"><FaRegCheckCircle className="text-yellow-600 mt-1" />Premium grades with uniform size & taste</li>
                        <li className="flex items-start gap-3"><FaRegCheckCircle className="text-yellow-600 mt-1" />Rich source of protein, magnesium & antioxidants</li>
                        <li className="flex items-start gap-3"><FaRegCheckCircle className="text-yellow-600 mt-1" />Available salted, unsalted, and roasted</li>
                        <li className="flex items-start gap-3"><FaRegCheckCircle className="text-yellow-600 mt-1" />Perfect for retail, gifting & wholesale exports</li>
                    </ul>
                </div>
            </section>

            {/* Specifications Section */}
            <section className="bg-yellow-50 py-14 px-4" data-aos="fade-up">
                <div className="max-w-5xl mx-auto">
                    <h3 className="text-3xl font-bold text-yellow-700 text-center mb-10">Product Specifications</h3>
                    <div className="grid md:grid-cols-2 gap-8">
                        <table className="w-full text-sm border border-yellow-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 text-left bg-yellow-100">Grade</th>
                                    <td className="p-4">W180, W210, W240, W320</td>
                                </tr>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 bg-yellow-100">Origin</th>
                                    <td className="p-4">India (Goa, Kerala, Maharashtra)</td>
                                </tr>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 bg-yellow-100">Shelf Life</th>
                                    <td className="p-4">12 months</td>
                                </tr>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 bg-yellow-100">Packaging Options</th>
                                    <td className="p-4">10kg / 25kg Vacuum, Tin & Box Pack</td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-yellow-100">Moisture Content</th>
                                    <td className="p-4">Less than 5%</td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="w-full text-sm border border-yellow-200 rounded-lg shadow-md">
                            <tbody>
                                <tr className="border-b border-yellow-200">
                                    <th className="p-4 text-left bg-yellow-100">Nutritional Value (per 100g)</th>
                                    <td className="p-4">
                                        Calories: 553 kcal<br />
                                        Protein: 18g<br />
                                        Fat: 44g (mostly unsaturated)<br />
                                        Carbs: 30g<br />
                                        Fiber: 3g
                                    </td>
                                </tr>
                                <tr>
                                    <th className="p-4 bg-yellow-100">Usage</th>
                                    <td className="p-4">
                                        Snacking, Bakery, Sweets, Gifting, Trail Mix, Health Bars, Cooking
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* Quality & Logistics Icons Section */}
            <section className="max-w-6xl mx-auto py-16 px-4 grid md:grid-cols-4 gap-6 text-center" data-aos="fade-up">
                <div>
                    <FaSeedling className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Ethically Sourced</h4>
                </div>
                <div>
                    <FaBoxOpen className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Tamper-proof Packaging</h4>
                </div>
                <div>
                    <FaShippingFast className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Worldwide Shipping</h4>
                </div>
                <div>
                    <FaRegCheckCircle className="text-4xl mx-auto text-yellow-600 mb-2" />
                    <h4 className="font-semibold text-gray-700">Quality Certified</h4>
                </div>
            </section>

            {/* Enquiry Section */}
            <section className="bg-yellow-100 py-10 px-4" data-aos="fade-up">
                <div className="max-w-xl mx-auto text-center">
                    <h3 className="text-2xl font-bold text-yellow-800 mb-4">Send Us an Enquiry</h3>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Your Email Address"
                        className="w-full p-3 rounded border border-yellow-300 mb-4 focus:outline-none"
                    />
                    <button
                        onClick={handleEnquiry}
                        className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-2 rounded-lg transition-all"
                    >
                        Send Enquiry
                    </button>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Cashew;
